import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import { SiteContentProvider } from './hooks/useSiteContent';
import { SiteLayout } from './components/SiteLayout';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
import { PortFeaturesPage } from './pages/PortFeaturesPage';
import { SustainabilityPage } from './pages/SustainabilityPage';
import { NewsPage } from './pages/NewsPage';
import { NewsDetailPage } from './pages/NewsDetailPage';
import { CareersPage } from './pages/CareersPage';
import { ContactPage } from './pages/ContactPage';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    // "/hizmetler#konteyner-operasyonlari" gibi linklerde hedef bolum icerik API'den
    // geldikten sonra olusur; kisa bir sure bekleyerek bolume kaydirilir.
    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    const timer = window.setInterval(() => {
      const target = document.getElementById(id);
      attempts += 1;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.clearInterval(timer);
      } else if (attempts > 20) {
        window.clearInterval(timer);
      }
    }, 150);
    return () => window.clearInterval(timer);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <LanguageProvider>
      <SiteContentProvider>
        <ScrollToTop />
        <SiteLayout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hizmetler" element={<ServicesPage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/liman-ozellikleri" element={<PortFeaturesPage />} />
            <Route path="/haberler" element={<NewsPage />} />
            <Route path="/haberler/:slug" element={<NewsDetailPage />} />
            <Route path="/surdurulebilirlik" element={<SustainabilityPage />} />
            <Route path="/kariyer" element={<CareersPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SiteLayout>
      </SiteContentProvider>
    </LanguageProvider>
  );
}
